import { defineMessages } from "react-intl";

export const messages = defineMessages({
  closeButtonLabel: {
    id: "joinMeetingPopUp.button.close.label",
    defaultMessage: "Close",
    description: "Label for close button",
  },
});
